import React, { useEffect, useState } from "react";
import { API, UPLOADS } from "./../../config/api";
export default function ContactMsg() {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    fetchMessages();
  }, []);

  const fetchMessages = async () => {
    try {
      const res = await fetch(API.CONTACT);

      const data = await res.json();

      setMessages(data);
    } catch (error) {
      console.error("Fetch Error:", error);
    }
  };

  return (
    <div className="dashboard-content">
      <h2 className="machine-title">Contact Messages</h2>

      <div className="table-responsive">
        <table className="machine-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Email</th>
              <th>Subject</th>
              <th>Mobile No</th>
              <th>Message</th>
              <th>Date</th>
            </tr>
          </thead>

          <tbody>
            {messages.length > 0 ? (
              messages.map((item, index) => (
                <tr key={item.id}>
                  <td data-label="#">{index + 1}</td>
                  <td data-label="Name">{item.name}</td>
                  <td data-label="Email">{item.email}</td>
                  <td data-label="Subject">{item.subject}</td>
                  <td data-label="Phone">{item.phone}</td>
                  <td data-label="Message">{item.message}</td>
                  <td data-label="Date & Time">{item.created_at}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="6"
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  No Messages Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
